<div [formGroup]="dataForm" class="fx-layout-row fx-layout-align-start-m fx-layout-align-center-x fx-gap-20">
  <div>
    <mat-form-field>
      <mat-label>Description</mat-label>
      <input formControlName="summary" matInput>
    </mat-form-field>
  </div>
  <div>
    <df-date-range formControlName="activityDate" label="Activity Date"></df-date-range>
  </div>

  <div>
    <mat-form-field>
      <mat-label>Activity Type</mat-label>
      <mat-select formControlName="activityType" name="activityType">
        @for (lookup of activityTypeLookupData; track lookup.id) {
          <mat-option [value]="lookup.id">
            {{ lookup.text }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</div>
